/**
 * SEO 工具函数
 */

/**
 * 获取当前页面的完整 URL（用于 Canonical URL）
 * @param {string} path - 路由路径，例如 '/timers' 或 '/'
 * @returns {string} 完整的 URL
 */
export function getCanonicalUrl(path = '') {
  // 获取当前域名和协议
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  
  // 如果 path 为空或是 '/', 返回首页
  if (!path || path === '/') {
    return origin + '/';
  }
  
  // 确保 path 以 / 开头
  const normalizedPath = path.startsWith('/') ? path : '/' + path;
  
  // 移除末尾的斜杠（除非是根路径）
  const cleanPath = normalizedPath === '/' ? '/' : normalizedPath.replace(/\/$/, '');
  
  return origin + cleanPath;
}

/**
 * 获取当前页面的路径（从 window.location.pathname）
 * @returns {string} 当前路径
 */
export function getCurrentPath() {
  if (typeof window === 'undefined') {
    return '/';
  }
  return window.location.pathname;
}

